import { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { Link } from "react-router-dom"
import axios from "axios"
import AppLayout from "@/components/app/AppLayout"
import { API_BASE } from "@/config/api"
import { HrSubnav } from "./HrSubnav"

const API = API_BASE

export default function HrOnboarding() {
  const { t } = useTranslation()
  const [employees, setEmployees] = useState([])

  useEffect(() => {
    axios.get(`${API}/hr/employees`).then(async (r) => {
      const withTasks = await Promise.all(
        r.data.map(async (e) => {
          try {
            const { data: tasks } = await axios.get(`${API}/hr/onboarding/${e.id}`)
            const done = tasks.filter((t) => t.completed_at).length
            return { ...e, tasks, progress: tasks.length ? Math.round((done / tasks.length) * 100) : 0 }
          } catch {
            return { ...e, tasks: [], progress: 0 }
          }
        })
      )
      setEmployees(withTasks)
    }).catch(() => {})
  }, [])

  return (
    <AppLayout title={t("app.hr.onboarding.title")}>
      <HrSubnav />
      <p className="text-sm text-muted-foreground mb-4">Training GDPR, proceduri cabinet, semnături.</p>
      <ul className="space-y-3">
        {employees.map((e) => (
          <li key={e.id} className="rounded-xl border border-border p-4 flex justify-between items-center">
            <div>
              <p className="font-medium">{e.first_name} {e.last_name}</p>
              <p className="text-xs text-muted-foreground">{e.role_code} · {e.progress}% complet</p>
            </div>
            <Link to={`/app/hr/employees/${e.id}`} className="text-sm text-primary hover:underline">Deschide checklist</Link>
          </li>
        ))}
      </ul>
    </AppLayout>
  )
}
